<div class="watch btn-rbv-dropdown" dropdown>
  <div class="watch-action hinted" dropdownToggle [ngClass]="{'watching': currentReport && currentReport.IS_WATCHING}">
    <fa name="fa fa-eye"></fa>
    <div class="counter">{{currentReport?.WATCHERS?.length}}</div>

    <div class="hint" *ngIf="hint">{{hint}}</div>
  </div>

  <div *dropdownMenu class="drop-menu dropdown-menu-right rounded-0 width-200">
    <a class="drop-item" (click)="stopWatching()" *ngIf="currentReport.IS_WATCHING">
      <fa name="fa fa-eye-slash" style="width: 20px;"></fa>
      <div class="text">Stop Watching</div>
    </a>

    <a class="drop-item" (click)="startWatching()" *ngIf="!currentReport.IS_WATCHING">
      <fa name="fa fa-eye" style="width: 20px;"></fa>
      <div class="text">Start Watching</div>
    </a>

    <a class="drop-item no-watchers-container" *ngIf="currentReport?.WATCHERS?.length === 0">
      <div class="no-watchers"></div>
      <p>No watchers yet</p>
    </a>

    <ng-container  *ngIf="currentReport?.WATCHERS?.length > 0">
      <div class="header">Watching this Report</div>

      <a class="drop-item" *ngFor="let watcher of currentReport?.WATCHERS">
        <div class="user">
          <ngx-avatar [name]="watcher.FIRST_NAME + ' ' + watcher.LAST_NAME" size="20"></ngx-avatar>
          <div class="user-name">{{watcher.FIRST_NAME + ' ' + watcher.LAST_NAME}}</div>
        </div>
      </a>
    </ng-container>

  </div>
</div>

